'use client';

import { styled } from 'styled-components';
import Link from 'next/link';
import {
  TRANSITION_DURATION,
  BREAKPOINT_DRAWER,
  BREAKPOINT_FULL,
} from '@content/navigation/navData';
import { WISTIA_GIT } from '@lib/constants';
import { trackLink } from '@lib/tracking';

const CtaLink = styled(Link)`
  color: ${({ theme }) => theme.colors.blue800};

  /** custom per design: H4/Mobile in the drawer, bodySm in the navbar */
  font-family: var(--font-walsheim);
  font-size: ${({ theme }) => theme.typography.fontSize.headingFour};
  font-weight: ${({ theme }) => theme.typography.fontWeight.link};
  line-height: ${({ theme }) => theme.typography.lineHeight.button};
  padding-block: ${({ theme }) => theme.spacing[0.75]};
  padding-inline: ${({ theme }) => theme.spacing[1.25]};
  text-align: center;
  transition: color ${TRANSITION_DURATION} linear;
  white-space: nowrap;
  width: 100%;

  &:hover,
  &:active {
    color: ${({ theme }) => theme.colors.blue500};
  }

  @media screen and (min-width: ${BREAKPOINT_DRAWER}) {
    font-size: ${({ theme }) => theme.typography.fontSize.bodySm};
  }

  @media screen and (min-width: ${BREAKPOINT_FULL}) {
    margin-inline-end: ${({ theme }) => theme.spacing[0.25]};
    padding: ${({ theme }) => theme.spacing[0.5]};
  }

  // for a total of 20px between link & ctas
  ${({ theme }) => theme.mq.minWidth.xl} {
    margin-inline-end: ${({ theme }) => theme.spacing[0.75]};
  }
`;

const SalesCta = () => {
  const handleClick = () => {
    trackLink('talk-to-sales-nav', 'navbar-cta');
  };

  return (
    <CtaLink
      className="sales"
      href={`${WISTIA_GIT}?cta=nav`}
      onClick={handleClick}
    >
      Talk to Sales
    </CtaLink>
  );
};

export default SalesCta;
